import(/* webpackMode: "eager", webpackExports: ["DocsNavigation"] */ "/vercel/path0/apps/web/app/(marketing)/docs/_components/docs-navigation.tsx");
